import React from "react";
import { Box, useTheme } from "@mui/material";
import CustomTypography from "../../../../../../views/components/common/form/CustomTypography";
import { RedemptionHow } from "../../../../../../models/Dashboard/Redemption/RedemptionSummary";
import RedemptionHint from "./RedemptionHint";

export const RedemptionEmptyState = ({ message }: { message: string }) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="10rem"
      textAlign="center"
      border="1px dashed"
      borderColor="divider"
      borderRadius={2}
      px={2}
    >
      <CustomTypography
        variant="heading6"
        fontWeight={500}
        color={theme.palette.customColors.greyTextColor}
      >
        {message}
      </CustomTypography>
    </Box>
  );
};

export const RedemptionSectionLabel = ({
  label,
  action,
  hint,
  how,
}: {
  label: string;
  action?: React.ReactNode;
  hint?: string | null;
  how?: RedemptionHow | null;
}) => {
  const theme = useTheme();
  const ruleColor = theme.palette.customColors.lightGray;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        mt: 3,
        mb: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <CustomTypography
          variant="heading8"
          fontWeight={600}
          color={theme.palette.customColors.greyTextColor}
          sx={{ letterSpacing: "0.05em", textTransform: "uppercase" }}
        >
          {label}
        </CustomTypography>
        <RedemptionHint text={hint} how={how} fontSize={14} />
      </Box>
      <Box sx={{ flex: 1, height: "1px", bgcolor: ruleColor }} />
      {action}
    </Box>
  );
};
